import './editor.scss';
import './style.scss';
// Import JS for front-end
import './script.js';